import React from 'react';

import SPAPill from '@/components/admin/SysadminSPA/shared/SPAPill';

import { OpenerFormat } from './types';

const LABELS: Partial<Record<OpenerFormat, string>> = {
  legacy: 'Old-format opener — no lesson-opener layout online',
  missing_title: 'Opener missing its online title',
};

// Flags an opener whose online body predates the modern .lesson-opener + h1 convention. Modern
// openers (and non-opener sections) render nothing.
const OpenerFormatNote = ({ format }: { format?: OpenerFormat | null }) => {
  const label = format ? LABELS[format] : undefined;
  if (!label) return null;

  return <SPAPill tone="warning">{label}</SPAPill>;
};

export default OpenerFormatNote;
